import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "text-align-left-16", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("path", { fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeWidth: 1.5, d: "M2.75 3.75h10.5m-10.5 4h5.5m-5.5 4h8.5" }));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
